// import { Injectable } from '@angular/core';
// import {AuthService} from '@core/services/auth.service'
// import {
//   HttpInterceptor,
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpHeaders,
//   HttpErrorResponse
// } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { Router } from '@angular/router';
// import { catchError } from 'rxjs/operators';
// @Injectable({
//   providedIn: 'root'
// })
// export class InterceptorService implements HttpInterceptor {
//   constructor(public router: Router, private auth: AuthService) {
//     console.log(this.auth.accessToken);
//   }
//   handleError(error: HttpErrorResponse) {
//     if (error.status === 401) {
//         console.log('error');
//         // this.router.navigate(['/auth/login']);
//     }
//     return throwError(error.error);
//   }
//   intercept(
//     req: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     console.log('Request Calling');
//     const authReq = req.clone({
//       headers: new HttpHeaders({
//         Authorization: `Bearer ${this.auth.accessToken}`
//       })
//     });
//     return next.handle(authReq).pipe(catchError(this.handleError));
//   }
// }
import { Injectable } from '@angular/core';
import {AuthService} from  '@app/services/authentication/auth.service'
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
@Injectable({
    providedIn: 'root'
  })
export class InterceptorService implements HttpInterceptor {
    constructor( public router: Router, private auth:AuthService ) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let addAuthToken = true;
        // console.log(request.url.search('/oauth2/token'),request.url);
        if(request.url.search('/oauth2/token') > 0 || request.url.search('https://files-scraper') === 0 || request.url.search('https://resources') === 0) {
            addAuthToken = false;
        }
        if(addAuthToken) {
            request = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${this.auth.accessToken}`
                }
            });
        }
    return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
            // let res = event;
            // if (event instanceof HttpResponse) {
                // console.log('event--->>>', event.status);
            // }
             return event;
        }),
        catchError((error: HttpErrorResponse) => {
         // console.log(error);
            if (error.status === 401) {
                //this.auth.signOut();
               // this.router.navigate(['/auth/login']);
            }
            return throwError(error);
        })
        );
}
}
